import React, { Fragment } from "react";
import {
  Container,
  Divider,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  FormGroup,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Loading from "./Loading";
import { useTranslation } from "react-i18next";
import ErrorPage from "../../../../Components/GeneralComponents/errorPage/ErrorPage";
import useUpdate from "../../../../api/useUpdate";
import useFetchObjects from "../../../../api/useFetchObjects";
import { useAuth } from "../../../../context";

const Employees = () => {
  const { t } = useTranslation();
  const auth = useAuth();
  const user = auth?.user;
  const token = user?.token;

  const { data, isLoading, isError } = useFetchObjects(
    ["users"],
    `users/?call_center=true`,
    token
  );
  const { handleUpdate } = useUpdate("users", token);

  const handleSwitchChange = (id, currentValue) => {
    const updatedValue = !currentValue; // Toggle the current value
    handleUpdate(id, { is_exist: updatedValue });
  };

  if (isLoading) {
    return <Loading />;
  }

  if (isError) {
    return (
      <Grid container>
        <ErrorPage />
      </Grid>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ marginTop: 4 }}>
      <Paper elevation={3} sx={{ padding: 4, borderRadius: 2 }}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Typography variant="h4" color="primary" fontWeight={700}>
            {t("hr.employees")}
          </Typography>
        </Grid>

        <Divider sx={{ my: 2 }} />

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  {t("hr.no")}
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  {t("hr.firstName")}
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  {t("hr.lastName")}
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  {t("hr.position")}
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  {t("hr.call_center")}
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  {t("hr.callCenterManager")}
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  {t("hr.department")}
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  {t("hr.contractDate")}
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  {t("hr.contractDuration")}
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  {t("hr.available")}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{ bgcolor: "#ccfcfc" }}>
              {data?.map((item, i) => (
                <Fragment key={i}>
                  <TableRow
                    key={i}
                    sx={{
                      backgroundColor:
                        i % 2 === 0 ? "action.hover" : "background.default",
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell align="center">{item?.id}</TableCell>
                    <TableCell align="center">{item?.first_name}</TableCell>
                    <TableCell align="center">{item?.last_name}</TableCell>
                    <TableCell align="center">
                      {item?.display_position}
                    </TableCell>
                    <TableCell align="center">
                      {item?.call_center ? t("hr.yes") : t("hr.no")}
                    </TableCell>
                    <TableCell align="center">
                      {item?.is_manager_in_call_center
                        ? t("hr.yes")
                        : t("hr.no")}
                    </TableCell>
                    <TableCell align="center">
                      {item?.display_department}
                    </TableCell>
                    <TableCell align="center">{item?.contract_date}</TableCell>
                    <TableCell align="center">
                      {item?.available_contract_date}
                    </TableCell>
                    <TableCell align="center">
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={item.is_exist}
                              onChange={() =>
                                handleSwitchChange(item.id, item.is_exist)
                              }
                            />
                          }
                        />
                      </FormGroup>
                    </TableCell>
                  </TableRow>
                </Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Container>
  );
};

export default Employees;
